import { Col, Row, Tabs } from "antd";
import { useDealer } from "../../../../tools/api";
import { useEffect, useState } from "react";
import { complexDigitToman, convertToJalaliWithTime } from "../../../../tools/tools";
import "./tabs.scss";
import ChangeSimCard from "./list_of_history/change_sim";
import ChargesHistory from "./list_of_history/charges";
import PackageHistory from "./list_of_history/packages";

const HistoryPurchase = ({ sppurchaseid = null }) => {
  return (
    <>
      <Tabs
        className="tab-wallet"
        items={[
          {
            key: "profile_info",
            label: "شارژ",
            children: <ChargesHistory sppurchaseid={sppurchaseid} />,
          },
          {
            key: "history_purchase",
            label: "بسته",
            children: <PackageHistory sppurchaseid={sppurchaseid} />,
          },
          {
            key: "leftover",
            label: "تعویض سیم‌کارت",
            children: <ChangeSimCard sppurchaseid={sppurchaseid} />,
          },
        ]}
      />
    </>
  );
};

export default HistoryPurchase;
